export default __webpack_public_path__ + "static/media/colusa.7e41f98b.jpg";